const addPurchaseInfoToComment = (form) => {
    if (!form)
        return;
    const inputs = form.querySelectorAll('input');
    const comment = form.querySelector('textarea[name="order_comment"]');
    const inputsName = [
        'nazvanie_organizacii',
        'inn',
        'kpp',
        'rs',
        'bik_banka',
        'nazvanie_banka',
        'adres_registracii',
        'vinnomer',
        'model',
        'god_vypuska',
        'nds',
    ];
    if (!comment)
        return;
    let orderInfo = '';
    inputs && inputs.forEach(input => {
        if (inputsName.includes(input.name) && input.value != '') {
            orderInfo += `${input.placeholder}: ${input.value} \n`;
        }
    });
    comment.value = orderInfo;
};
export default addPurchaseInfoToComment;
